import React, { useState, useEffect } from 'react';
import Layout from '../../components/layout/Layout';
import DadosPessoais from '../../components/profile/DadosPessoais';
import DadosProfissionais from '../../components/profile/DadosProfissionais';
import DetalhesAssinatura from '../../components/profile/DetalhesAssinatura';
import ConfiguracoesGerais from '../../components/profile/ConfiguracoesGerais';
import AlterarSenha from '../../components/profile/AlterarSenha';
import useUserProfile from '../../hooks/useUserProfile';
import { getAuth } from 'firebase/auth';
import './UserProfile.css';

function UserProfile() {
  const [activeTab, setActiveTab] = useState('dados-pessoais');
  const { showProfessionalTab } = useUserProfile();
  const [photoURL, setPhotoURL] = useState('');

  useEffect(() => {
    const user = getAuth().currentUser;
    if (user && user.photoURL) {
      setPhotoURL(user.photoURL); // Inicializa o estado com o photoURL atual do usuário
    }
  }, []);

  const renderTabContent = () => {
    switch (activeTab) {
      case 'dados-pessoais':
        return <DadosPessoais setPhotoURL={setPhotoURL} photoURL={photoURL} />; // Passa o setPhotoURL e photoURL para DadosPessoais
      case 'alterar-senha':
        return <AlterarSenha />;
      case 'assinatura':
        return <DetalhesAssinatura />;
      case 'configuracoes':
        return <ConfiguracoesGerais />;
      case 'dados-profissionais':
        return showProfessionalTab && <DadosProfissionais />;
      default:
        return null;
    }
  };

  return (
    <Layout>
      <div className="user-profile">
        <h2>Meu Perfil</h2>
        <div className="tabs">
          <button
            className={`tab-button ${activeTab === 'dados-pessoais' ? 'active' : ''}`}
            onClick={() => setActiveTab('dados-pessoais')}
          >
            Dados Pessoais
          </button>
          {showProfessionalTab && (
            <button
              className={`tab-button ${activeTab === 'dados-profissionais' ? 'active' : ''}`}
              onClick={() => setActiveTab('dados-profissionais')}
            >
              Dados Profissionais
            </button>
          )}
          <button
            className={`tab-button ${activeTab === 'alterar-senha' ? 'active' : ''}`}
            onClick={() => setActiveTab('alterar-senha')}
          >
            Alterar Senha
          </button>
          <button
            className={`tab-button ${activeTab === 'assinatura' ? 'active' : ''}`}
            onClick={() => setActiveTab('assinatura')}
          >
            Assinatura
          </button>
          <button
            className={`tab-button ${activeTab === 'configuracoes' ? 'active' : ''}`}
            onClick={() => setActiveTab('configuracoes')}
          >
            Configurações
          </button>
        </div>
        <div className="tab-content">{renderTabContent()}</div>
      </div>
    </Layout>
  );
}

export default UserProfile;
